export default "__VITE_ASSET__Dn$fbEoB__"